/* eslint-disable react/jsx-props-no-spreading */
import { React, useState, useEffect, useContext, useMemo, useRef } from "react"; // , useCallback
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

// import { useHistory } from 'react-router-dom'; // Link,
import { Upload } from "@aws-sdk/lib-storage";
import { S3Client } from "@aws-sdk/client-s3";
import { FaFileDownload, FaTrash } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";
// import { useDropzone } from 'react-dropzone'; // ----FS
import { AgGridReact } from "ag-grid-react";
import { get, post } from "../Network/requests";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../Assets/css/table_grid.css";
import { getUrl } from "../Network/urls";
// import NoDataFoundComponent from './NoDataFoundComponent';
import { tokenExpire, isValidFile } from "../Utils";
import { MdOutlineDownload } from "react-icons/md";
import FileDownloadModal from "./FileDownloadModal";
// import FileDeleteModal from './FileDeleteModal';
import Loader from "./UI/Loader";
import "../Assets/css/file_storage.css";
import HeaderComponent from "./UI/HeaderComponent";
// import DragAndDropUpload from './UI/DragAndDropUpload';
import DragAndDropUploadComponent from "./UI/DragAndDropUploadComponent";
import FooterComponent from "./UI/FooterComponent";
import SidePanel from "./UI/SidePanel";
import AppContext from "../Store/AppContext";
import { trackFileDownload } from "../Analytics/analytics";
import { ModuleRegistry } from "ag-grid-community";
import { RowGroupingPanelModule } from "ag-grid-enterprise";
import { TbArrowsMinimize } from "react-icons/tb";
import { LuExpand } from "react-icons/lu";
import LinearLoader from "./UI/LinearLoader";
import FileDeleteModal from "./UI/FileDeleteModal";
import RefreshAndFullscreenActions from "./UI/RefreshAndFullscreenActions";
import FileUploadComponent from "./UI/FileUploadComponent";
import DragAndDropUpload from "./UI/DragAndDropUpload";
import axios from "axios";
import GridLoader from "./UI/GridLoader";

ModuleRegistry.registerModules([RowGroupingPanelModule]);

function FileStorageComponent() {
  const navigate = useNavigate();
  const {
    secretAccessId,
    secretAccessKey,
    clientDetails,
    encryptedClientValuesObj,
    handleDecryptResponse,
    handleAPIEncryptValue,
    handleEncryptOtherParamsOfAPI,
    inputBucketName,
  } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filesData, setFilesData] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [fileDownload, setFileDownload] = useState("");
  const [fileDelete, setFileDelete] = useState("");
  const [isFullscreen, setIsFullscreen] = useState(false);

  const [file, setFile] = useState({});
  const [progress, setProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const controllerRef = useRef(null);
  const [showAbortIcon, setShowAbortIcon] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const [debouncedIsDragOver, setDebouncedIsDragOver] = useState(false);
  const fileInputRef = useRef(null);
  // const clientDetails = JSON.parse(localStorage.getItem('clientDetails'));
  // let [uploadFile, setUploadFile] = useState([]);
  // const [isDragging, setIsDragging] = useState(false);
  // const [uploadedFiles, setUploadedFiles] = useState([]);
  // const [showComponent, setShowComponent] = useState(false);
  // const [isDragOver, setIsDragOver] = useState(false);
  const operation = "file_store";
  const defaultColDef = useMemo(
    () => ({
      filter: true,
      floatingFilter: false,
    }),
    []
  );

  const gridOptions = {
    pagination: true,
    paginationPageSize: 25,
    paginationPageSizeSelector: false,
  };

  const gridRef = useRef();
  const handleFileDownload = (obj) => {
    setFileDownload(obj.FileName);
    setShowDownloadModal(!showDownloadModal);
    trackFileDownload(obj.FileName);
  };

  const handleFileDeleteModal = (fileName) => {
    setFileDelete(fileName);
    setShowDeleteModal(true);
  };

  const getStoredFiles = () => {
    setIsLoading(true);
    const url = getUrl("get-file-storage");
    const data = {
      client_id: encryptedClientValuesObj.clientId,
      email_id: clientDetails.email,
    };
    const idToken = localStorage.getItem("userToken");
    const secretKey = idToken.slice(998, 1030);
    const regdataData = handleAPIEncryptValue(JSON.stringify(data));
    get(`${url}?regdata=${regdataData}`, true)
      // get(`${url}?client_id=${encryptedClientValuesObj.
      // clientId}&email_id=${clientDetails.email}`, true)
      .then((response) => {
        const {
          data: { encryptBody, statusCode, authData },
        } = response;
        setIsLoading(false);
        const finalArr = [];
        // console.log(finalArr);
        switch (statusCode) {
          case 200: {
            const iv = authData;
            const body = handleDecryptResponse(
              encryptBody.toString(),
              secretKey.toString(),
              iv.toString()
            );
            body.data.map((item) =>
              finalArr.push(
                item.reduce(
                  (prev, next, index) => ({
                    ...prev,
                    [body.columns[index]]: next,
                  }),
                  {}
                )
              )
            );
            setFilesData(finalArr);
            setColumnData([
              {
                headerName: "SN",
                field: "SN",
                width: 120,
                resizable: false,
                suppressMovable: true,
                cellStyle: { textAlign: "left" },
                filter: "agTextColumnFilter",
              },
              {
                headerName: "File Name",
                field: "FileName",
                width: 650,
                resizable: false,
                suppressMovable: true,
                flex: 1,
                cellStyle: { textAlign: "left" },
                headerClass: "header-center",
                filter: "agTextColumnFilter",
              },
              {
                headerName: "Type",
                field: "Type",
                width: 130,
                resizable: false,
                suppressMovable: true,
                cellStyle: { textAlign: "left" },
                filter: "agTextColumnFilter",
              },
              {
                headerName: "Date",
                field: "Date",
                width: 180,
                resizable: false,
                suppressMovable: true,
                cellStyle: { textAlign: "left" },
                filter: "agTextColumnFilter",
              },
              {
                headerName: "Time",
                field: "Time",
                width: 120,
                resizable: false,
                suppressMovable: true,
                cellStyle: { textAlign: "left" },
                filter: "agTextColumnFilter",
              },
              {
                headerName: "Download",
                field: "Download",
                resizable: false,
                width: 100,
                cellStyle: { textAlign: "left" },
                suppressMovable: true,
                filter: false,
                sortable: false,
                cellRenderer: (params) => (
                  <>
                    {/* {console.log('params :', params)} */}
                    {/* <FaFileDownload
                      style={{ cursor: "pointer", color: "#6c757d" }}
                      onClick={() => handleFileDownload(params.data)}
                    /> */}
                    <MdOutlineDownload
                      onClick={() => handleFileDownload(params.data)}
                      className="text-black cursor-pointer"
                      size={23}
                    />
                  </>
                ),
              },
              {
                headerName: "Delete",
                field: "Delete",
                resizable: false,
                width: 100,
                cellStyle: { textAlign: "left" },
                suppressMovable: true,
                filter: false,
                sortable: false,
                cellRenderer: (params) => (
                  <>
                    {/* <FaTrash
                      style={{ cursor: "pointer", color: "#6c757d" }}
                      onClick={() =>
                        handleFileDeleteModal(params.data.FileName)
                      }
                    /> */}
                    <FaTrash
                      style={{
                        cursor: "pointer",
                        color: "rgb(249 44 44 / 70%)",
                      }}
                      onClick={() =>
                        handleFileDeleteModal(params.data.FileName)
                      }
                    />
                  </>
                ),
              },
            ]);
            // toast.success('Successfully fetched files.');
            break;
          }
          case 400:
            toast.error("Error fetching the files.");
            break;
          case 401:
            toast.error("Unauthorized Access");
            break;
          default:
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        }
      })
      .catch((error) => {
        toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        tokenExpire(error.response, navigate);
        setIsLoading(false);
      });
  };

  const handleFileDelete = () => {
    setShowDeleteModal(false);
    setIsLoading(true);
    const url = getUrl("delete-file");
    const fileStore = "file_store";
    const paramsObj = { fileDelete, fileStore };
    const encryptedParamsObj = handleEncryptOtherParamsOfAPI(paramsObj);
    const dataPost = {
      client_id: encryptedClientValuesObj.clientId,
      file_name: encryptedParamsObj.fileDelete,
      operation: encryptedParamsObj.fileStore,
      email_id: clientDetails.email,
    };

    const regdataData = handleAPIEncryptValue(JSON.stringify(dataPost));

    const apiPayload = {
      httpMethod: "POST",
      parameters: regdataData,
      // parameters: {
      //   client_id: encryptedClientValuesObj.clientId,
      //   file_name: encryptedParamsObj.fileDelete,
      //   operation: encryptedParamsObj.fileStore,
      //   email_id: clientDetails.email,
      // },
    };
    const fileData = JSON.stringify(apiPayload);
    post(`${url}`, fileData, true)
      .then((response) => {
        const {
          data: { statusCode },
        } = response;
        setIsLoading(false);
        switch (statusCode) {
          case 200:
            toast.success("File deleted successfully.");
            getStoredFiles();
            break;
          case 400:
            toast.error("A server error occurred while deleting the file.");
            break;
          case 401:
            toast.error("Unauthorized Access");
            break;
          default:
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        }
      })
      .catch((error) => {
        toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        tokenExpire(error.response, navigate);
        setIsLoading(false);
      });
    // console.log(e);
  };

  const handleFileUpload = (e) => {
    // let productCode = 'file-storage';
    // let regulationCode = 'R001';
    // if (isValidFile(productCode, regulationCode, e)) {
    if (true) {
      for (let i = 0; i < e.length; i += 1) {
        let uploadFile = e[i];
        // console.log(uploadFile);
        const cred = {
          accessKeyId: secretAccessId,
          secretAccessKey: secretAccessKey,
        };
        let uploadFolder = `Common/${clientDetails.clientId}/`;
        try {
          const parallelUploads3 = new Upload({
            client: new S3Client({ region: "eu-west-2", credentials: cred }),
            params: {
              Bucket: inputBucketName,
              Key: `${uploadFolder}${uploadFile.name}`,
              Body: uploadFile,
            },
            // queueSize: 4, // optional concurrency configuration
            partSize: 1024 * 1024 * 300, // optional size of each part, in bytes, at least 5MB
            leavePartsOnError: false,
          }); // optional manually handle dropped parts
          parallelUploads3.done();
          toast.success("File uploaded successfully.");
          setTimeout(() => {
            getStoredFiles();
          }, 3000);
        } catch (error) {
          toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        }
      }
    } else {
      toast.error("File format is not accepted");
    }
  };
  const handleStopUploadOperation = () => {
    if (controllerRef.current) {
      try {
        controllerRef.current.abort();
        toast.info("Upload aborted", { autoClose: 1000 });
      } catch (e) {
        console.error("Abort failed:", e);
      }
    }
    setFile({});
    setProgress(0);
    setShowProgressBar(false);
    controllerRef.current = null;
    setShowAbortIcon(false);
  };

  const handleFileUploadToS3 = async (url, inputFile) => {
    const controller = new AbortController();
    controllerRef.current = controller;
    try {
      const res = await axios.put(url, inputFile, {
        signal: controller.signal,
        headers: {
          "Content-Type": file?.type,
        },
        onUploadProgress: (event) => {
          if (event.lengthComputable) {
            const fProgress = Math.round((event.loaded / event.total) * 100);
            // console.log('fProgress :', fProgress);
            setProgress(fProgress);
            if (fProgress < 100) {
              setShowAbortIcon(true);
            } else {
              setShowAbortIcon(false);
            }
          }
        },
      });
      switch (res.status) {
        case 200:
          setProgress(100);
          toast.success("File uploaded sucessfully");
          setTimeout(() => {
            getStoredFiles();
          }, 2000);
          setTimeout(() => {
            setShowProgressBar(false);
            setProgress(0);
            setFile({});
          }, 900); //Hide overlay for  short delay
          break;
        case 403:
          toast.error("Unauthorized. Please try again");
          setShowProgressBar(false);
          return;
        default:
          toast.error("Upload failed");
          setShowProgressBar(false);
          return;
      }
    } catch (error) {
      setShowProgressBar(false);
      if (error?.name === "CanceledError") {
        toast.error("File upload aborted");
      } else {
        toast.error(error?.message);
      }
    }
  };
  // console.log("client details :", clientDetails);
  const handleFileUploadDemo = (uploadFile) => {
    if (uploadFile) {
      setProgress(0);
      setFile(uploadFile);
      setShowProgressBar(true);
      setShowAbortIcon(false);
      let fileName = uploadFile.name?.replace(/\s+/g, "_");
      let regulationFolder = `Common/${clientDetails.clientId}/`;
      const bucketName = "input";
      const clientName = clientDetails?.clientName?.toLowerCase();
      const key = `${regulationFolder}${fileName}`;
      if (fileName && regulationFolder) {
        try {
          // console.log('key :', key);
          const paramsObj = { key, bucketName, clientName };
          // console.log("paramsObj :", paramsObj);
          const encryptedParamsObj = handleEncryptOtherParamsOfAPI(paramsObj);
          const data = {
            key: encryptedParamsObj?.key,
            bucket_name: encryptedParamsObj?.bucketName,
            client_id: encryptedClientValuesObj.clientId,
            client_name: encryptedParamsObj.clientName,
            email_id: clientDetails?.email,
          };
          const regdataData = handleAPIEncryptValue(JSON.stringify(data));
          const url = getUrl("get-presigned-url");
          get(`${url}?regdata=${regdataData}`, true)
            .then((response) => {
              const {
                data: { encryptBody, statusCode, authData },
              } = response;
              const iv = authData;
              const idToken = localStorage.getItem("userToken");
              const secretKey = idToken.slice(998, 1030);
              const body = handleDecryptResponse(
                encryptBody.toString(),
                secretKey.toString(),
                iv.toString()
              );
              switch (statusCode) {
                case 200:
                  // console.log("body :", body);
                  const presignedURL = body?.URL;
                  fileInputRef.current.value = "";
                  return presignedURL;
                case 400:
                  toast.error(body);
                  setShowProgressBar(false);
                  return null;
                case 401:
                  toast.error(body);
                  setShowProgressBar(false);
                  tokenExpire(statusCode, navigate); // logout
                  return null;
                default:
                  toast.error("Unexpected error");
                  setShowProgressBar(false);
                  return null;
              }
            })
            .then((presignedURL) => {
              if (presignedURL) {
                setShowAbortIcon(true);
                handleFileUploadToS3(presignedURL, uploadFile, true);
              }
            });
        } catch (error) {
          console.log("errror :", error);
          toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
          tokenExpire(error.response, navigate);
          setShowProgressBar(false);
        }
      }
    } else {
      toast.error("File format is not accepted");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  // const handleDragUpload = (e) => {
  //   console.log(e);
  //   handleFileUpload(e);
  // };

  // const handleDragOver = (e) => {
  //   e.preventDefault();
  //   setIsDragOver(true);
  // };

  // const handleDragLeave = () => {
  //   setIsDragOver(false);
  // };

  // const handleDrop = (e) => {
  //   e.preventDefault();
  //   setIsDragOver(false);
  //   const files = Array.from(e.dataTransfer.files);
  //   console.log(files, '====files');
  //   handleFileUpload(files);
  // };

  // -----------------------------------------------
  // const handleDragEnter = (e) => {
  //   e.preventDefault();
  //   setIsDragging(true);
  // };

  // const handleDragLeave = (e) => {
  //   e.preventDefault();
  //   setIsDragging(false);
  // };

  // const handleDragOver = (e) => {
  //   e.preventDefault(); // Necessary for the drop event to work
  //   setIsDragging(true);
  // };

  // const handleDrop = (e) => {
  //   console.log(e, '--handleDrop');
  //   e.preventDefault();
  //   setIsDragging(false);
  //   handleFileUpload(e);
  //   let { files } = e.dataTransfer || {};
  //   console.log(files, '---handleDrop files');
  //   if (files && files.length > 0) {
  //     handleFileUpload(files[0]);
  //     // handleFileUpload(e);
  //   }
  // };

  // const handleFileInputChange = (e) => {
  //   console.log(e, '---e');
  //   let file = e.target.files[0]; // comment this and send e
  //   console.log(file, '---handleFileInputChange');
  //   handleFileUpload(file);
  // };

  // const onDrop = useCallback((e) => { // -----------FS
  //   // Do something with the files
  //   console.log(e, '1');
  //   // let uFiles = [];
  //   // uFiles = JSON.stringify(e);
  //   // console.log(uFiles, '2');
  //   handleFileUpload(e[0]);
  // }, []);
  // const { getRootProps, isDragActive } = useDropzone({ onDrop }); // ----------FSgetInputProps,

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedIsDragOver(isDragOver);
    }, 200);

    return () => clearTimeout(timeout);
  }, [isDragOver]);

  const handleDragOver = (e) => {
    const hasFiles = Array.from(e.dataTransfer.types).includes("Files");
    if (hasFiles) {
      e.preventDefault();
      if (!isDragOver) setIsDragOver(true);
    }
  };

  const handleDragLeave = (e) => {
    const hasFiles = Array.from(e.dataTransfer.types).includes("Files");
    if (hasFiles) {
      e.preventDefault();
      setIsDragOver(false);
    }
  };

  const handleDrop = (e) => {
    const hasFiles = Array.from(e.dataTransfer.types).includes("Files");
    if (hasFiles) {
      e.preventDefault();
      handleFileUploadDemo(e.dataTransfer.files[0]);
      setIsDragOver(false);
    }
  };

  useEffect(() => {
    if (Object.keys(encryptedClientValuesObj).length > 0) {
      getStoredFiles();
    }

    // const timeout = setTimeout(() => {
    //   // setShowComponent(true);
    // }, 5000);

    // return () => clearTimeout(timeout);
  }, [encryptedClientValuesObj]);

  return (
    <>
      <HeaderComponent visibility="true" productName="File Storage" />
      <div className="sidebar">
        <SidePanel />
      </div>
      <>
        <div
          className={`pt-0 dashboard_inner_fs ${debouncedIsDragOver && "p-0"} ${
            isFullscreen ? "fullscreen-grid m-0" : "mt-3"
          }`}
        >
          <div
            className="position-relative"
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            onDragLeave={handleDragLeave}
          >
            <DragAndDropUpload debouncedIsDragOver={debouncedIsDragOver} />
            <div className="d-flex align-items-center justify-content-between">
              <FileUploadComponent
                handleStopUploadOperation={handleStopUploadOperation}
                fileInputRef={fileInputRef}
                showProgressbar={showProgressBar}
                progress={progress}
                file={file}
                onUpload={handleFileUploadDemo}
                showAbortIcon={showAbortIcon}
                showUploadComponent
                fileStorage
              />
              <div className="d-flex justify-content-end">
                <RefreshAndFullscreenActions
                  isFullscreen={isFullscreen}
                  onToggleFullscreen={() =>
                    setIsFullscreen((fullScreen) => !fullScreen)
                  }
                  onRefresh={getStoredFiles}
                  iconDisabled={isLoading}
                />
              </div>
            </div>
            <div className="rx_table_wrapper table-responsive padding-fix">
              <div className="container-fluid p-0">
                <div
                  className="ag-theme-alpine ag-theme-quartz"
                  style={{
                    height: isFullscreen ? "calc(100vh - 60px)" : "80vh",
                    width: "100%",
                  }}
                >
                  {isLoading ? (
                    <GridLoader />
                  ) : (
                    <AgGridReact
                      theme="legacy"
                      key={filesData.length}
                      ref={gridRef}
                      // rowGroupPanelShow="always"
                      rowData={filesData}
                      columnDefs={columnData}
                      animateRows
                      enableCellTextSelection
                      gridOptions={gridOptions}
                      rowStyle={{ color: "black" }}
                      // onGridReady={getStoredFiles}
                      defaultColDef={defaultColDef}
                    />
                  )}
                </div>
              </div>
            </div>
            {showDownloadModal && (
              <FileDownloadModal
                show={showDownloadModal}
                onHide={() => setShowDownloadModal(false)}
                onDownload={fileDownload}
                operation={operation}
                source="file_store"
                productCode="d"
                regulationCode="d"
              />
            )}
            <FileDeleteModal
              setShowDeleteModal={setShowDeleteModal}
              showDeleteModal={showDeleteModal}
              handleOnClick={handleFileDelete}
            />
          </div>
        </div>
      </>
      <FooterComponent />
    </>
  );
}
export default FileStorageComponent;
